'use strict'
import moment from 'moment'
import api from '@/api/api';
import userService from '../../services/user.service'

const CHANGE_NAME       = 'CHANGE_NAME',
      SET_WEEK          = 'SET_WEEK',
      GETTING_INFO      = 'GET_INFO',
      GET_INFO_SUCCESS  = 'GET_INFO_SUCCESS',
      CHANGE_DEPTO      = 'CHANGE_DEPTO',
      GET_REPORT_SUCCESS = 'GET_REPORT_SUCCESS',
      DOWNLOADING       = 'DOWNLOADING',
      DOWNLOAD_SUCCESS  = 'DOWNLOAD_SUCCESS';

export default {
    namespaced: true,
    state:{
        place: 'La Paz',
        department: 'Corte',
        week: '',
        loading: false,
        data: [],
        report: [],
        dText: 'Descargar .CSV',
        dflag: false,
    },
    getters: {
        getName(state){
            return state.place;
        },
        getDep(state){
            return state.department;
        },
        getWeek(state){
            return state.week;
        },
        loading(state) {
            return state.loading;
        },
        data(state) {
            return state.data;
        },
        report(state){
            return state.report;
        },
        downloadFlag(state){
            return state.dflag;
        },
        downloadText(state){
            return state.dText;
        }
    },
    mutations: {
        [CHANGE_NAME](state, payload){
            state.place = payload;
        },
        [CHANGE_DEPTO](state, payload){
            state.department = payload;
        },
        [SET_WEEK](state, payload){
            state.week = payload;
        },
        [GETTING_INFO](state) {
            state.loading = true;
            state.data = [];
        },
        [GET_INFO_SUCCESS](state, change) {
            state.loading = false;
            state.data = change;
        },
        [GET_REPORT_SUCCESS](state, change) {
            state.report = change;
        },
        [DOWNLOADING](state, change) {
            state.dflag = false;
            state.dText = change;
        },
        [DOWNLOAD_SUCCESS](state, change) {
            state.dflag = true;
            state.dText = change;
        }
    },
    actions:{
        week({commit}){
            let startOfWeek = moment().startOf('isoweek').locale('es').format('dddd D [a]');
            let endOfWeek   = moment().endOf('isoweek').locale('es').format(' dddd D [de] MMMM[,] YYYY');
            let weeek = startOfWeek + endOfWeek;
            commit(SET_WEEK, weeek)
        },
        async getInfo({ commit }, city){
            let token = userService.getToken();
            let identity = userService.decode(token);
            let citylink = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
           
            let cityUser='';
            if(identity.city=='cancun'){
                cityUser = 'Cancún'
            }else if(identity.city=='cdmexico'){
                cityUser = 'Cd. México'
            }else if(identity.city=='culiacan'){
                cityUser  ='Culiacán'
            }else if(identity.city=='guadalajara'){
                cityUser ='Guadalajara'
            }else if(identity.city=='hermosillo'){
                cityUser = 'Hermosillo'
            }else if(identity.city=='juarez'){
                cityUser  ='Juárez'
            }else if(identity.city=='lapaz'){
                cityUser = 'La Paz'
            }else if(identity.city=='merida'){
                cityUser = 'Mérida'
            }else if(identity.city=='mexicali'){
                cityUser = 'Mexicali'
            }else if(identity.city=='monterrey'){
                cityUser  ='Monterrey'
            }else if(identity.city=='nogales'){
                cityUser ='Nogales'
            }else if(identity.city=='queretaro'){
                cityUser = 'Querétaro'
            }else if(identity.city=='tijuana'){
                cityUser  ='Tijuana'
            }else if(identity.city=='veracruz'){
                cityUser = 'Veracruz'
            }else if(identity.city=='villahermosa'){
                cityUser = 'Villahermosa'
            }
      

            if(identity.role =='056'  || identity.role =='1001'){
                if( identity.city == citylink){
                    commit(CHANGE_NAME, city)
                    commit(GETTING_INFO);
                    let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    let response = await api.getDeptos(link);
                    commit(GET_INFO_SUCCESS, response.data);
                    return response.data;
                }else{
                    commit(CHANGE_NAME, cityUser)
                    commit(GETTING_INFO);
                    let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    let response = await api.getDeptos(link);
                    commit(GET_INFO_SUCCESS, response.data);
                    return response.data;
                }
               
            }else if(identity.role =='1002'){
                if(identity.num == 10191){ // tijuana - mexicali- lapaz
                    if( citylink == 'lapaz' || citylink == 'tijuana' ||  citylink == 'mexicali'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if(identity.num == 10290){
                    if( citylink == 'nogales' || citylink == 'hermosillo' ||  citylink == 'culiacan'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if(identity.num == 985177){
                    if( citylink == 'nogales' || citylink == 'cancun' ||  citylink == 'merida'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if(identity.num == 10264 ){
                    if( citylink == 'juarez' || citylink == 'monterrey'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if( identity.num =='9999994'){
                    if( citylink == 'juarez' || citylink == 'monterrey'  || citylink == 'merida' || citylink == 'hermosillo'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if(identity.num == 10261){
                    if( citylink == 'guadalajara' || citylink == 'queretaro' ||  citylink == 'cdmexico'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }else if(identity.num == 10237){
                    if( citylink == 'veracruz' || citylink == 'merida' ||  citylink == 'villahermosa' ||  citylink == 'cancun'){
                        commit(CHANGE_NAME, city)
                        commit(GETTING_INFO);
                        let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }else{
                        commit(CHANGE_NAME, cityUser)
                        commit(GETTING_INFO);
                        let link =  cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        let response = await api.getDeptos(link);
                        commit(GET_INFO_SUCCESS, response.data);
                        return response.data;
                    }
                }

            }else{
                commit(CHANGE_NAME, city)
                commit(GETTING_INFO);
                try {
    
                    
                    let link = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    let response = await api.getDeptos(link);
                    commit(GET_INFO_SUCCESS, response.data);
                    return response.data;
                } catch (error) {
                  //console.log(error)
                }
            }

            
        },
        async getReportsInfo({ commit }){
            try {                
                let response = await api.getReportData();
                commit(GET_REPORT_SUCCESS, response.data.reporte);
                return response.data.reporte;
            } catch (error) {
              //console.log(error)
            }
        },
        changeDeptos({commit}, city){

            let token = userService.getToken();
            let identity = userService.decode(token);
            let citylink = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
           
            let cityUser='';
            if(identity.city=='cancun'){
                cityUser = 'Cancún'
            }else if(identity.city=='cdmexico'){
                cityUser = 'Cd. México'
            }else if(identity.city=='culiacan'){
                cityUser  ='Culiacán'
            }else if(identity.city=='guadalajara'){
                cityUser ='Guadalajara'
            }else if(identity.city=='hermosillo'){
                cityUser = 'Hermosillo'
            }else if(identity.city=='juarez'){
                cityUser = 'Juárez'
            }else if(identity.city=='lapaz'){
                cityUser = 'La Paz'
            }else if(identity.city=='merida'){
                cityUser = 'Mérida'
            }else if(identity.city=='mexicali'){
                cityUser = 'Mexicali'
            }else if(identity.city=='monterrey'){
                cityUser  ='Monterrey'
            }else if(identity.city=='nogales'){
                cityUser ='Nogales'
            }else if(identity.city=='queretaro'){
                cityUser = 'Querétaro'
            }else if(identity.city=='tijuana'){
                cityUser  ='Tijuana'
            }else if(identity.city=='veracruz'){
                cityUser = 'Veracruz'
            }else if(identity.city=='villahermosa'){
                cityUser = 'Villahermosa'
            }
            

          
           // Restringir deptos segun el rol.
            if(identity.role =='056' || identity.role =='1001'){
                if( identity.city == citylink){
                    if(city == 'Juárez'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                        });
                    }else if(city == 'La Paz'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'La Paz',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                        });
                    }else if(city == 'Cancún'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Cancún',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                        });
                    }else if(city == 'Cd. México'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Cd. México',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                        });
                    }else if(city == 'Culiacán'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Culiacán',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Culiacán',
                            depName: 'Corte'
                        });
                    }else if(city == 'Guadalajara'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Guadalajara',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Guadalajara',
                            depName: 'Corte'
                        });
                    }else if(city == 'Hermosillo'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Hermosillo',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Hermosillo',
                            depName: 'Corte'
                        });
                    }else if(city == 'Mérida'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Mérida',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Mérida',
                            depName: 'Corte'
                        });
                    }else if(city == 'Mexicali'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Mexicali',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Mexicali',
                            depName: 'Corte'
                        });
                    }else if(city == 'Monterrey'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Monterrey',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Monterrey',
                            depName: 'Corte'
                        });
                    }else if(city == 'Veracruz'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Veracruz',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Veracruz',
                            depName: 'Corte'
                        });
                    }else if(city == 'Villahermosa'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Villahermosa',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Villahermosa',
                            depName: 'Corte'
                        });
                    }else if(city == 'Nogales'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Nogales',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Nogales',
                            depName: 'Corte'
                        });
                    }else if(city == 'Querétaro'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Querétaro',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Querétaro',
                            depName: 'Corte'
                        });
                    }else if(city == 'Tijuana'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });

                        this.dispatch('plants/getBonos', {
                            cityName: 'Tijuana',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Tijuana',
                            depName: 'Corte'
                        });
                    }
                }else{
                    if(cityUser == 'Juárez'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'La Paz'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'La Paz',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                        });
                    }else if(cityUser == 'Cancún'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Cancún',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Cancún',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Cd. México'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Cd. México',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Cd. México',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Culiacán'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Culiacán',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Culiacán',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Guadalajara'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Guadalajara',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Guadalajara',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Hermosillo'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Hermosillo',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Hermosillo',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Mérida'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Mérida',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Mérida',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Mexicali'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Mexicali',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Mexicali',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Monterrey'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Monterrey',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Monterrey',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Veracruz'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Veracruz',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Veracruz',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Villahermosa'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Villahermosa',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Villahermosa',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Nogales'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Nogales',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Nogales',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Querétaro'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Querétaro',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Querétaro',
                            depName: 'Corte'
                        });
                    }else if(cityUser == 'Tijuana'){
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Tijuana',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Tijuana',
                            depName: 'Corte'
                        });
                    }
                }
               
            }else if(identity.role =='1002'){
                if(identity.num == 10191){ // tijuana - mexicali- lapaz
                    if( citylink == 'lapaz' || citylink == 'tijuana' ||  citylink == 'mexicali'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }else if(identity.num == 10290){
                    if( citylink == 'nogales' || citylink == 'hermosillo' ||  citylink == 'culiacan'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }else if(identity.num == 10264){
                    if( citylink == 'juarez' || citylink == 'monterrey'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }else if( identity.num =='9999994'){
                    if( citylink == 'juarez' || citylink == 'monterrey' || citylink == 'merida' || citylink == 'hermosillo'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                          
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        commit(CHANGE_DEPTO, 'Corte');
                        let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                        this.dispatch("plants/getBDInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch("plants/getAllInfo", {
                            department: 'Corte',
                            city: nCity
                        });
                        this.dispatch('plants/getBonos', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                        });
                        this.dispatch('plants/getProduccion', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                        });
                    }
                }else if(identity.num == 10261){
                    if( citylink == 'guadalajara' || citylink == 'queretaro' ||  citylink == 'cdmexico'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }else if(identity.num == 10237){
                    if( citylink == 'veracruz' || citylink == 'merida' ||  citylink == 'villahermosa' ||  citylink == 'cancun'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }else if(identity.num == 985177){
                    if(  citylink == 'merida' ||  citylink == 'cancun'){
                        if(city == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(city == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(city == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(city == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(city == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(city == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(city == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(city == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(city == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(city == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(city == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(city == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(city == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(city == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }else{
                        if(cityUser == 'Juárez'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Juárez',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'La Paz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'La Paz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                    cityName: 'La Paz',
                                    depName: 'Corte'
                            });
                        }else if(cityUser == 'Cancún'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cancún',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Cd. México'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Cd. México',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Culiacán'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Culiacán',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Guadalajara'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Guadalajara',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Hermosillo'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Hermosillo',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mérida'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mérida',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Mexicali'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Mexicali',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Monterrey'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Monterrey',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Veracruz'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Veracruz',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Villahermosa'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Villahermosa',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Nogales'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Nogales',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Querétaro'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Querétaro',
                                depName: 'Corte'
                            });
                        }else if(cityUser == 'Tijuana'){
                            commit(CHANGE_DEPTO, 'Corte');
                            let nCity = cityUser.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                            this.dispatch("plants/getBDInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch("plants/getAllInfo", {
                                department: 'Corte',
                                city: nCity
                            });
                            this.dispatch('plants/getBonos', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                            this.dispatch('plants/getProduccion', {
                                cityName: 'Tijuana',
                                depName: 'Corte'
                            });
                        }
                    }
                }

            }else{
                if(city == 'Juárez'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Juárez',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Juárez',
                            depName: 'Corte'
                    });
                }else if(city == 'La Paz'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'La Paz',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'La Paz',
                            depName: 'Corte'
                    });
                }else if(city == 'Cancún'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Cancún',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Cancún',
                            depName: 'Corte'
                    });
                }else if(city == 'Cd. México'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Cd. México',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Cd. México',
                            depName: 'Corte'
                    });
                }else if(city == 'Culiacán'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Culiacán',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Culiacán',
                            depName: 'Corte'
                    });
                }else if(city == 'Guadalajara'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Guadalajara',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Guadalajara',
                            depName: 'Corte'
                    });
                }else if(city == 'Hermosillo'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Hermosillo',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Hermosillo',
                            depName: 'Corte'
                    });
                }else if(city == 'Mérida'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Mérida',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Mérida',
                            depName: 'Corte'
                    });
                }else if(city == 'Mexicali'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Mexicali',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Mexicali',
                            depName: 'Corte'
                    });
                }else if(city == 'Monterrey'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Monterrey',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Monterrey',
                            depName: 'Corte'
                    });
                }else if(city == 'Veracruz'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Veracruz',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Veracruz',
                            depName: 'Corte'
                    });
                }else if(city == 'Villahermosa'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Villahermosa',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Villahermosa',
                            depName: 'Corte'
                    });
                }else if(city == 'Nogales'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Nogales',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Nogales',
                            depName: 'Corte'
                    });
                }else if(city == 'Querétaro'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Querétaro',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Querétaro',
                            depName: 'Corte'
                    });
                }else if(city == 'Tijuana'){
                    commit(CHANGE_DEPTO, 'Corte');
                    let nCity = city.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f-\s-\.]/g, "");
                    this.dispatch("plants/getBDInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch("plants/getAllInfo", {
                        department: 'Corte',
                        city: nCity
                    });
                    this.dispatch('plants/getBonos', {
                        cityName: 'Tijuana',
                        depName: 'Corte'
                    });
                    this.dispatch('plants/getProduccion', {
                            cityName: 'Tijuana',
                            depName: 'Corte'
                    });
                }
            }

           
        }
    }
}